import React, { useState } from "react"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import { Layout, ConfigProvider } from "antd"
import { UserProvider, useUser } from "./contexts/UserContext"
import { CardsProvider } from "./contexts/CardsContext"
import { ProductProvider } from "./contexts/ProductContext"
import { FlowProvider } from "./contexts/FlowContext"
import { ResellerProvider } from "./contexts/ResellerContext"
import { ThresholdProvider } from "./contexts/ThresholdContext"
import ProtectedRoute from "./components/ProtectedRoute"
import FixedSider from "./FixedSider"
import SmartProductsDashboard from "./components/Dashboard/User/SmartProductsDashboard"
import AdminDashboard from "./components/Dashboard/Admin/AdminDashboard"
import SensorGraph from "./components/SensorGraph"
import WaterQualityTable from "./components/WaterQualityTable"
import FlowCalculator from "./FlowCalculator"
import Login from "./pages/Login/Login"
import RegisterUser from "./pages/Login/RegisterUser"
import AccountManager from "./pages/AccountManagement"
import EditAccount from "./pages/EditAccount"
import ResetPassword from "./pages/Login/ResetPassword"
import ResetPasswordConfirm from "./pages/Login/ResetPasswordConfirm"
import MistralComponent from "./components/MistralComponent"
import ProductManagement from "./components/ProductManagement"
import EditThresholds from "./components/EditThresholds"
import CardDetails from "./pages/CardDetails/CardDetails"
import { mockProducts } from "./components/mockProducts"
import "antd/dist/reset.css"
import "./App.css"
import { I18nextProvider } from "react-i18next"
import i18n from "./translations/i18n"
//import { Notifications } from 'react-push-notification';
import EventNotifications from './Notifications/NotificationScript.js'

import { Helmet } from 'react-helmet';
import { CookiesProvider, useCookies } from 'react-cookie'
import { useTranslation } from "react-i18next"
import { BrowserView, MobileView, isMobile } from 'react-device-detect';

const { Content } = Layout

function App() {
    const [siderCollapsed, setSiderCollapsed] = useState(true)
    const { t } = useTranslation()

    const toggleSider = () => {
        setSiderCollapsed(!siderCollapsed)
    }

    const addProduct = (productData) => {
        console.log("Adding product:", productData)
    }

    const productContextValue = {
        addProduct
    }

    return (
        <>
            <Helmet>
                <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="f4d5ca5a-614c-49b7-87d7-ef094a8071e9" type="text/javascript"></script>
            </Helmet>
        <I18nextProvider i18n={i18n} defaultNS={"translation"}>
                <EventNotifications>
                    <CookiesProvider>
                        <ConfigProvider>
                            <UserProvider>
                                <CardsProvider>
                                    <ProductProvider value={productContextValue}>
                                        <FlowProvider>
                                            <ResellerProvider>
                                                <ThresholdProvider>
                                                    <Router>
                                                        <Layout style={{ minHeight: "100vh" }}>
                                                           
                                                            <FixedSider toggleSider={toggleSider} />
                                                            <Layout className="site-layout">
                                                                <MobileView>
                                                                    <div style={{height: "80px", width:"100%"}}></div>
                                                                </MobileView>
                                                                {/*<header>
                                                                    {siderCollapsed ? null : <div style={{ top: "200px" }} onClick={toggleSider}></div>}
                                                                    {/*<div className="logo">
                                                                       <img src="/AquaExpert2024_blue_lay.png" alt="Aqua Expert Logo" />
                                                                    </div>}
                                                                </header>*/}
                                                                <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
                                                                    <div className="site-layout-background" style={{ minHeight: 360 }}>
                                                                        <AppRoutes />
                                                                    </div>
                                                                </Content>
                                                                <div style={{ height: "20px", width: "100%" }}></div>
                                                                <h3 style={{ margin: "0", height: "80px", width: "100%", position: "relative", display: "block", backgroundColor: "#001529", minHeight: "50px", textAlign: "center" }}><p style={{ lineHeight: "35px", color: "white", fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'", fontSize: "18px" }}>{t('page.header')}</p></h3>
                                                            </Layout>
                                                        </Layout>
                                                    </Router>
                                                </ThresholdProvider>
                                            </ResellerProvider>
                                        </FlowProvider>
                                    </ProductProvider>
                                </CardsProvider>
                            </UserProvider>
                        </ConfigProvider>
                    </CookiesProvider>
                </EventNotifications>
        </I18nextProvider>
        </>
    )
}

function AppRoutes() {
    const { user } = useUser()

    return (
        <div>
            <Routes>
                <Route exact 
                    path="/dashboard"
                    element={
                        <ProtectedRoute allowedRoles={["User", "Reseller", "Admin", "SuperAdmin"]}>
                            <AdminDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route exact
                    path="/sensorlog/:id/:sensor"
                    element={
                        <ProtectedRoute allowedRoles={["User", "Reseller", "Admin", "SuperAdmin"]}>
                            <SensorGraph />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/dashboard/card/:id"
                    element={
                        <ProtectedRoute allowedRoles={["User", "Reseller", "Admin", "SuperAdmin"]}>
                            <CardDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/flow"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <FlowCalculator />
                        </ProtectedRoute>
                    }
                />
                {/*<Route
                    path="/table"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <WaterQualityTable />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/mistral"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <MistralComponent />
                        </ProtectedRoute>
                    }
                />*/}
                <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
                <Route
                    path="/register-user"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin", "Reseller"]}>
                            <RegisterUser />
                        </ProtectedRoute>
                    }
                />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />
                {/*<Route
                    path="/product-management"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <ProductManagement />
                        </ProtectedRoute>
                    }
                />*/}
                {/*<Route
                    path="/edit-thresholds"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <EditThresholds />
                        </ProtectedRoute>
                    }
                />*/}
                <Route 
                    path="/accountmanager"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin"]}>
                            <AccountManager />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/edit-account/:userid"
                    element={
                        <ProtectedRoute allowedRoles={["Admin", "SuperAdmin", "Reseller", "User"]}>
                            <EditAccount />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        !!user ? (
                                <AdminDashboard />
                        ) : (
                            <Login />
                        )
                    }
                />
            </Routes>
        </div>
        )
}

export default App
